import { FunctionComponent } from 'react';
import { BodyText, Div } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

const ExitVerificationFlow: FunctionComponent = () => {
  const { t } = useTranslation('phoneNumberVerification');

  return (
    <Div>
      <BodyText>{t('ExitVerificationFlow.bodyText')}</BodyText>
    </Div>
  );
};

export default ExitVerificationFlow;
